import axios from 'axios';
export async function generateAccomplishmentReport(payload = {}) {
    // Validate the input and construct the payload
    if (!payload || typeof payload !== 'object') {
        console.error('Invalid payload: Must be a non-empty object.');
        return null;
    }

    try {
        // Log the payload for debugging
        console.log('Posting payload to API Gateway:', payload);

        // Make the API call
        const response = await fetch('https://fferu0h6el.execute-api.ap-southeast-1.amazonaws.com/prod/accomplishmentReportGenerator', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        // Check for a successful response
        if (response.ok) {
            const result = await response.json();
            console.log('Successfully processed payload:', result);
            return result; // Return the response as JSON
        } else {
            // Log detailed error information
            console.error(`Error: Failed to process payload. Status: ${response.status}`);
            const errorDetails = await response.text();
            console.error('Response details:', errorDetails);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while posting the payload.', error);
        return null;
    }
}

